<form class="flex flex-wrap gap-2 mt-4" role="search" aria-label="Pesquisar perfis" (ngSubmit)="buscar()">
  <input
    [formControl]="buscaControl"
    type="search"
    class="form-input w-64"
    placeholder="Pesquise por Nome"
    aria-label="Pesquise por Nome"
  />
  <button type="submit" title="Pesquisar perfis" class="px-5 min-w-max btn btn--secondary h-35">
    <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
  </button>
  <button
    type="button"
    title="Limpar busca"
    (click)="limparBusca()"
    class="px-5 min-w-max btn btn--primary h-35 bg-blumine"
  >
    <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
  </button>
</form>

<div *ngIf="roles.length > 0" class="flex flex-col">
  <!-- <h1 class="text-lg font-bold leading-3">LISTA DE PAPÉIS</h1> -->
  <div class="overflow-x-auto">
    <div class="inline-block min-w-full py-2 overflow-x-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th
                scope="col"
                class="px-6 py-3 pl-0 font-bold leading-5 tracking-wider text-left uppercase text-chathams-blue"
                style="width: 150px"
              >
                Perfil
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-bold leading-5 tracking-wider text-center uppercase text-chathams-blue"
                style="width: 150px"
              >
                Total de Usuários<br />Cadastrados
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-bold leading-5 tracking-wider text-left uppercase text-chathams-blue"
              >
                Observações
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-bold leading-5 tracking-wider text-right uppercase text-chathams-blue"
                style="width: 150px"
                *isAllowed="[ERoleAdminString.Admin, 'role.update', 'role.disable']"
              >
                Mais
              </th>
            </tr>
          </thead>

          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let role of roles">
              <td
                class="px-6 py-4 pl-0 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap"
              >
                {{ role.description }}
              </td>
              <td
                class="px-6 py-4 font-medium leading-4 tracking-wider text-center text-md text-chathams-blue whitespace-nowrap"
              >
                {{ role.adminUsers.length }}
              </td>
              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue">
                {{ role.comments }}
              </td>
              <td
                class="w-24 py-4 text-md text-chathams-blue whitespace-nowrap flex justify-around float-right"
                *isAllowed="[ERoleAdminString.Admin, 'role.update', 'role.disable']"
              >
                <button
                  *isAllowed="[ERoleAdminString.Admin, 'role.update']"
                  [routerLink]="'gerenciamento/' + role.id"
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#000000"
                    width="20"
                    height="20"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>
                <button
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  aria-label="Example icon-button with a menu "
                >
                  <mat-icon class="w-6 h-6">more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button
                    *isAllowed="[ERoleAdminString.Admin, 'role.update']"
                    mat-menu-item
                    (click)="duplicarRole(role.id)"
                  >
                    <mat-icon>content_copy</mat-icon>
                    <span>Duplicar</span>
                  </button>
                  <button
                    *isAllowed="[ERoleAdminString.Admin, 'role.disable']"
                    mat-menu-item
                    (click)="deletarRole(role.id)"
                  >
                    <mat-icon>delete</mat-icon>
                    <span>Deletar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
          <div class="flex float-right"></div>
        </table>
      </div>
    </div>
  </div>
</div>
<app-no-results-found [condition]="roles.length === 0"></app-no-results-found>

<nav class="flex items-center justify-between px-4 py-3 pl-0">
  <div class="hidden sm:block"></div>
  <div class="flex justify-end flex-1 gap-1">
    <app-paginacao
      [numeroDeItens]="totalDeItens"
      [tamanhoDaPagina]="quantidadeItensPorPagina"
      [paginaSelecionada]="paginaSelecionada"
      [totalPage]="totalPage"
      (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    ></app-paginacao>
  </div>
</nav>
